import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

const webApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const nativeApiBaseUrl = import.meta.env.VITE_NATIVE_API_BASE_URL;
const localWebApiBaseUrl = new URL('/roade/api/v1', window.location.origin).toString().replace(/\/$/, '');

export const API_BASE_URL = isNative
  ? nativeApiBaseUrl || webApiBaseUrl || 'https://roade-be.ngrok.dev/roade/api/v1'
  : webApiBaseUrl || (import.meta.env.DEV ? localWebApiBaseUrl : 'https://api.roade.ro/roade/api/v1');

export const getBaseHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'accept': '*/*',
    'ROADE-API-TIME-ZONE': 'Europe/Bucharest',
    'ROADE-API-LOCALE': 'ro_RO',
    'ROADE-CLIENT-PLATFORM': Capacitor.getPlatform().toUpperCase(),
  };

  // Add ngrok bypass header for native platforms
  if (isNative) {
    headers['ngrok-skip-browser-warning'] = 'true';
  }

  return headers;
};
